import React, { useRef } from "react";
import T from "i18n-react";
//@ts-ignore
import PhoneInput from "react-phone-input-2";
import Button from "../Widgets/Button";
import "react-phone-input-2/lib/style.css";
import Styles from "./styles.module.scss";
import { useSelector } from "react-redux";
import { RedirectURLKeys } from "../../utils/redirectHistory";

interface ILoginComponentProps {
  phoneNumber: string;
  setPhoneNumber: (value: string) => void;
  loginLoading: boolean;
  loginFunction: () => void;
}

function Login({
  phoneNumber,
  setPhoneNumber,
  loginLoading,
  loginFunction,
}: ILoginComponentProps) {
  const LoginPage = useSelector((state: any) => state.LoginRedirectToMainPage);
  const ref = useRef<HTMLInputElement>();
  function displayText() {
    if (
      LoginPage === RedirectURLKeys.Payment ||
      LoginPage === RedirectURLKeys.PaymentGroup
    ) {
      return (
        <T.p
          className={Styles.Text1}
          text={{ key: "Login.Texts.letsCompleteOrder" }}
        />
      );
    }
    return <T.p className={Styles.Text1} text={{ key: "Login.Texts.lets" }} />;
  }
  return (
    <div>
      <div>
        {displayText()}
        <p className={Styles.Text2}>
          {T.translate("Login.Texts.enterMobile")}
          <br />
          <strong>{T.translate("Login.Texts.SignInProfile")}</strong>{" "}
        </p>
      </div>

      <div className={Styles.SectionDivs} id="PhoneInputDiv">
        <PhoneInput
          value={phoneNumber}
          disableSearchIcon={true}
          inputProps={{
            autoFocus: ref && ref.current ? true : false,
          }}
          country={"gb"}
          onChange={setPhoneNumber}
          enableSearch={false}
          className="PhoneNumberInput"
          ref={ref}
        />
        <T.p
          className={Styles.InputGuideText}
          text={{ key: "Login.Texts.phoneExampleText" }}
        />
      </div>
      <div
        className={Styles.SectionDivs}
        style={{
          marginTop: "26px",
        }}
      >
        <Button
          onClick={loginFunction}
          isLoading={loginLoading}
          iconClassName={"consumer-right-arrow"}
          dataComponentName="SendTextButton"
          className={Styles.ContinueButton}
          title="Continue"
        />
      </div>
    </div>
  );
}

export default Login;
